// import { db } from "../../Firebase_Config/firebaseConfig";
// import {
//   collection,
//   query,
//   where,
//   onSnapshot,
// }from "firebase/firestore";
// import { useEffect, useState } from "react";


// const formatLabel = (value = "") => {
//   return value
//     .toString()
//     .toLowerCase()
//     .split(" ")
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(" ");
// };



// const FilterSection = ({ title, children, defaultOpen = false }) => {
//   const [open, setOpen] = useState(defaultOpen);

//   return (
//     <div>
//       <button
//         onClick={() => setOpen(!open)}
//         className="w-full flex items-center justify-between text-left font-medium"
//       >
//         <span>{title}</span>
//         <span className="text-xl">{open ? "−" : "+"}</span>
//       </button>

//       <div className="h-px bg-blue-900 my-3" />

//       {open && <div className="space-y-2">{children}</div>}
//     </div>
//   );
// };
// const FilterCheckbox = ({ label, checked, onChange }) => (
//   <label className="flex items-center gap-3 text-sm text-gray-900 cursor-pointer">
//     <input
//       type="checkbox"
//       checked={checked}
//       onChange={onChange}
//       className="h-4 w-4 rounded border-gray-400 accent-blue-900"
//     />
//     {label}
//   </label>
// );



// const OpenPositions = () => {
//   const [showApplyForm, setShowApplyForm] = useState(false);
//   const [applyJob, setApplyJob] = useState(null);
//   const [expandedJobId, setExpandedJobId] = useState(null);
//   const [filters, setFilters] = useState({
//   location: [],
//   jobType: [],
//   experience: [],
//   areaOfInterest: [],
// });
// const clearFilters = () => {
//   setFilters({
//     location: [],
//     jobType: [],
//     experience: [],
//     areaOfInterest: [],
//   });
// };

// const toggleFilter = (key, value) => {
//   setFilters((prev) => {
//     const exists = prev[key].includes(value);
//     return {
//       ...prev,
//       [key]: exists
//         ? prev[key].filter((v) => v !== value)
//         : [...prev[key], value],
//     };
//   });
// };

// const [sortBy, setSortBy] = useState("newest");





// const [formData, setFormData] = useState({
//   name: "",
//   email: "",
//   phone: "",
//   message: "",
//   resumeLink: "",
//   photoLink: "",
//   linkedin: "",
//   github: "",
// });
// const COMPANY = "valsco";


// const [submitting, setSubmitting] = useState(false);


//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedJob, setSelectedJob] = useState(null);
// useEffect(() => {
//   if (selectedJob) {
//     const scrollY = window.scrollY;

//     document.body.style.position = "fixed";
//     document.body.style.top = `-${scrollY}px`;
//     document.body.style.left = "0";
//     document.body.style.right = "0";
//     document.body.style.width = "100%";
//   } else {
//     const scrollY = Math.abs(
//       parseInt(document.body.style.top || "0", 10)
//     );

//     document.body.style.position = "";
//     document.body.style.top = "";
//     document.body.style.left = "";
//     document.body.style.right = "";
//     document.body.style.width = "";

//     window.scrollTo(0, scrollY);
//   }

//   return () => {
//     document.body.style.position = "";
//     document.body.style.top = "";
//     document.body.style.left = "";
//     document.body.style.right = "";
//     document.body.style.width = "";
//   };
// }, [selectedJob]);





//   useEffect(() => {
//     const q = query(
//       collection(db, "job-openings"),
//       where("isOpen", "==", true),
//       where("company.valsco", "==", true) 
//     );

//     const unsubscribe = onSnapshot(q, (snapshot) => {
//       const data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       setJobs(data);
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   const filteredJobs = jobs
//   .filter((job) => {
//     if (
//       filters.location.length &&
//       !filters.location.includes(job.location)
//     )
//       return false;

//     if (
//       filters.jobType.length &&
//       !filters.jobType.includes(job.jobType)
//     )
//       return false;

//     // EXPERIENCE FILTER
// // EXPERIENCE FILTER
// if (filters.experience.length) {
//   const expText = job.experience?.toString().toLowerCase() || "";

//   // extract number from "3 years", "2", etc.
//   const match = expText.match(/\d+/);
//   const years = match ? parseInt(match[0], 10) : null;

//   const matchesRange = filters.experience.some(range => {
//     // 0–2 includes empty / missing experience
//     if (range === "0-2") {
//       if (years === null) return true;
//       return years >= 0 && years <= 2;
//     }

//     // other ranges REQUIRE a number
//     if (years === null) return false;

//     if (range === "2-5") return years >= 2 && years <= 5;
//     if (range === "6-10") return years >= 6 && years <= 10;
//     if (range === "10+") return years > 10;

//     return false;
//   });

//   if (!matchesRange) return false;
// }



//     // AREA OF INTEREST FILTER (based on job.title)
// if (filters.areaOfInterest.length) {
//   const title = job.title?.toLowerCase() || "";

//   const hasMatch = filters.areaOfInterest.some(area =>
//     title.includes(area)
//   );

//   if (!hasMatch) return false;
// }

//     return true;
//   })
//   .sort((a, b) => {
//     if (sortBy === "newest") {
//       return (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0);
//     }
//     if (sortBy === "oldest") {
//       return (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0);
//     }
//     return 0;
//   });

//   const locationOptions = Array.from(
//   new Set(
//     jobs
//       .map((job) => job.location)
//       .filter(Boolean) // removes null / undefined
//   )
// );

// const jobTypeOptions = Array.from(
//   new Set(
//     jobs
//       .map((job) => job.jobType)
//       .filter(Boolean)
//   )
// );




//   return (
    
//     <section className="py-4 bg-white-50" id="open-positions">
//       <div className="max-w-7xl mx-auto px-6">
//         {/* Header */}
//         <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
//   {/* LEFT */}
//   <div>
//     <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
//       Open Positions
//     </h2>
//     <p className="mt-1 text-gray-600 text-sm md:text-base">
//       Roles currently open at Valsco Technology.
//     </p>
//   </div>

//   {/* RIGHT */}
//   <div className="flex items-center justify-between md:justify-end gap-4 text-sm">
//     <span className="text-gray-700">
//       <strong>{filteredJobs.length}</strong> Results
//     </span>

//     <select
//       value={sortBy}
//       onChange={(e) => setSortBy(e.target.value)}
//       className="border rounded-md px-3 py-2 text-sm"
//     >
//       <option value="newest">Sort by Newest</option>
//       <option value="oldest">Sort by Oldest</option>
//     </select>
//   </div>
// </div>



// <div className="grid grid-cols-1 md:grid-cols-[260px_1fr] gap-10">
//   {/* FILTERS */}
// {/* FILTERS CARD */}
// {/* FILTERS CARD */}
// <div className="bg-white rounded-2xl p-6 border border-gray-200">
//   {/* Header */}
//   <div className="flex items-center justify-between mb-6">
//     <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
//     <button
//       onClick={clearFilters}
//       className="text-blue-900 text-sm flex items-center gap-1 hover:underline"
//     >
//       Clear filters ⟳
//     </button>
//   </div>

//   <div className="space-y-6">
//     {/* LOCATION */}
//     <FilterSection title="Location">
//       {locationOptions.map((loc) => (
//   <FilterCheckbox
//     key={loc}
//     label={formatLabel(loc)}
//     checked={filters.location.includes(loc)}
//     onChange={() => toggleFilter("location", loc)}
//   />
// ))}

//     </FilterSection>

//     {/* AREA OF INTEREST */}
//     <FilterSection title="Area of Interest">
//       {["Frontend", "Backend", "Business Developement", "Law Intern", "Sales", "Social Media Marketing","UI UX Developement"].map(
//         (area) => (
//           <FilterCheckbox
//             key={area}
//             label={area}
//             checked={filters.areaOfInterest.includes(area.toLowerCase())}

//             onChange={() =>
//   toggleFilter("areaOfInterest", area.toLowerCase())
// }

//           />
//         )
//       )}
//     </FilterSection>

//     {/* JOB TYPE */}
//     <FilterSection title="Job Type">
//       {jobTypeOptions.map((type) => (
//   <FilterCheckbox
//     key={type}
//     label={type}
//     checked={filters.jobType.includes(type)}
//     onChange={() => toggleFilter("jobType", type)}
//   />
// ))}

//     </FilterSection>

//     {/* EXPERIENCE */}
//     <FilterSection title="Experience">
//       {["0-2", "2-5", "6-10", "10+"].map((exp) => (
//         <FilterCheckbox
//           key={exp}
//           label={exp}
//           checked={filters.experience.includes(exp)}
//           onChange={() => toggleFilter("experience", exp)}
//         />
//       ))}
//     </FilterSection>
//   </div>
// </div>




//         {/* Content */}
//         {loading ? (
//   <div className="flex items-center justify-center py-20">
//     <p className="text-gray-500">Loading openings…</p>
//   </div>
// ) : filteredJobs.length === 0 ? (
//   <div className="flex items-center justify-center py-20">
//     <p className="text-gray-500 text-lg text-center max-w-md">
//       No open roles right now. Please check back soon.
//     </p>
//   </div>
// ) : (

//           <div className="open-jobs-scroll flex flex-col gap-6 max-h-[70vh] overflow-y-auto pr-3">



  


//             {filteredJobs.map((job) => {


//   const isExpanded = expandedJobId === job.id;

//   return (
//     <div
//       key={job.id}
//       className="w-full bg-white border border-gray-200 rounded-xl px-8 py-6 transition-all hover:shadow-md"

//     >
//       {/* HEADER */}
//       <div className="flex justify-between items-start">
//         <div>
//           <h3 className="text-xl font-semibold text-gray-900">
//             {job.title}
//           </h3>

//           <p className="mt-2 text-sm text-gray-500">
//   {job.location || "Remote"} |{" "}
//   {job.jobType || "Full time"} |{" "}
//   Experience: {job.experience || "—"} |{" "}
//   Salary: {job.salary || "—"}
// </p>

//         </div>

//         {/* + / - BUTTON */}
//         <button
//           onClick={() =>
//             setExpandedJobId(isExpanded ? null : job.id)
//           }
//           className="h-10 w-10 bg-[#1b1761] text-white rounded-md text-xl hover:opacity-90"

//         >
//           {isExpanded ? "−" : "+"}
//         </button>
//       </div>

//       {/* EXPANDED CONTENT */}
//       {isExpanded && (
//   <div className="mt-6 text-gray-700 space-y-4">


//           <div>
//             <strong className="text-gray-900">Job Description</strong>
//             <p className="mt-2 whitespace-pre-line text-gray-700">
//   {job.description}
// </p>

//           </div>

//           <div className="pt-4">
//             <button
//               onClick={() => {
//                 setApplyJob(job);
//                 setShowApplyForm(true);
//               }}
//               className="px-8 py-3 bg-[#1b1761] text-white rounded-lg hover:opacity-90 transition"

//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// })}

//           </div>
//         )}
//       </div>
//       {selectedJob && (
//   <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4">
    
//     {/* MODAL CONTAINER */}
//     <div className="bg-white w-full max-w-lg rounded-2xl relative flex flex-col max-h-[90vh]">


//       {/* HEADER (NON-SCROLLING) */}
//       <div className="shrink-0 px-8 pt-8 pb-4 border-b relative">
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
//           onClick={() => setSelectedJob(null)}
//         >
//           ✕
//         </button>

//         <h3 className="text-2xl font-semibold text-gray-900">
//           {selectedJob.title}
//         </h3>

//         <p className="mt-2 whitespace-pre-line text-gray-700">
//           {selectedJob.jobType || "Role"} · {selectedJob.location || "Remote"}
//         </p>
//       </div>

//       {/* BODY (SCROLLS IF CONTENT IS LONG) */}
//       <div className="flex-1 overflow-y-auto px-8 py-6 text-sm text-gray-700 space-y-4">
//         <div>
//           <strong>Description</strong>
//           <p className="mt-1 whitespace-pre-line break-words">
//             {selectedJob.description || "No description provided."}
//           </p>
//         </div>

//         {selectedJob.salary && (
//           <div>
//             <strong>Salary</strong>
//             <p>{selectedJob.salary}</p>
//           </div>
//         )}

//         <div>
//           <strong>Company</strong>
//           <p>Valsco Technology</p>
//         </div>

//         <div>
//           <strong>Status</strong>
//           <p>{selectedJob.isOpen ? "Open" : "Closed"}</p>
//         </div>
//       </div>

//       {/* FOOTER (NON-SCROLLING) */}
//       <div className="shrink-0 px-8 py-6 border-t flex justify-center">
//         <button
//   type="button"
//   className="px-10 py-3 min-w-[220px] rounded-lg bg-[#1b1761] text-white"
//   onClick={(e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setSelectedJob(null);      // close view
//     setApplyJob(selectedJob);  // pass job
//     setShowApplyForm(true);
//   }}
// >
//   Apply
// </button>

//       </div>

//     </div>
//   </div>
// )}

// {showApplyForm && applyJob && (
//   <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center px-4">
//     <div className="bg-white w-full max-w-lg rounded-2xl relative flex flex-col max-h-[90vh]">


//       <div className="shrink-0 px-8 pt-8 pb-4 border-b relative">
//   <button
//     className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
//     onClick={() => setShowApplyForm(false)}
//   >
//     ✕
//   </button>

//   <h3 className="text-2xl font-semibold text-gray-900">
//     Apply for {applyJob.title}
//   </h3>
// </div>

//       <form
//   id="apply-form"
//   className="flex-1 overflow-y-auto px-8 py-6 space-y-4"
//   onSubmit={async (e) => {
//     e.preventDefault();
//     setSubmitting(true);

//     try {
//       const form = new FormData();
//       form.append("jobTitle", applyJob.title);
//       form.append("company", COMPANY);  
//       form.append("name", formData.name);
//       form.append("email", formData.email);
//       form.append("phone", formData.phone);
//       form.append("message", formData.message);
//       form.append("resumeLink", formData.resumeLink);
//       form.append("photoLink", formData.photoLink);
//       form.append("linkedin", formData.linkedin);
//       form.append("github", formData.github);

//       await fetch(
//         "https://script.google.com/macros/s/AKfycbyabONFenc7qmuXrmVO3fntc5z53eOUursP8SglMxuq0iA-BEeezabpWHG39cBg7zw_Vg/exec",
//         { method: "POST", body: form , mode:"no-cors"}
//       );

//       alert("Application submitted successfully!");
//       setShowApplyForm(false);
//     } catch (err) {
//       console.error(err);
//       alert("Submission failed");
//     } finally {
//       setSubmitting(false);
//     }
//   }}
// >

//         <input
//           required
//           placeholder="Full Name"
//           className="w-full border rounded-lg px-4 py-2"
//           onChange={(e) =>
//             setFormData({ ...formData, name: e.target.value })
//           }
//         />

//         <input
//           required
//           type="email"
//           placeholder="Email"
//           className="w-full border rounded-lg px-4 py-2"
//           onChange={(e) =>
//             setFormData({ ...formData, email: e.target.value })
//           }
//         />

//         <input
//           required
//           placeholder="Phone"
//           className="w-full border rounded-lg px-4 py-2"
//           onChange={(e) =>
//             setFormData({ ...formData, phone: e.target.value })
//           }
//         />
//         <p className="text-xs text-gray-500">
//   Please ensure links are publicly accessible (Google Drive preferred).
// </p>


//         <input
//   required
//   type="url"
//   placeholder="Resume Drive Link"
//   className="w-full border rounded-lg px-4 py-2"
//   onChange={(e) =>
//     setFormData({ ...formData, resumeLink: e.target.value })
//   }
// />

// <input
//   type="url"
//   placeholder="Passport Size Photo Drive Link"
//   className="w-full border rounded-lg px-4 py-2"
//   onChange={(e) =>
//     setFormData({ ...formData, photoLink: e.target.value })
//   }
// />

// <input
//   type="url"
//   placeholder="LinkedIn Profile Link"
//   className="w-full border rounded-lg px-4 py-2"
//   onChange={(e) =>
//     setFormData({ ...formData, linkedin: e.target.value })
//   }
// />

// <input
//   type="url"
//   placeholder="GitHub Profile Link"
//   className="w-full border rounded-lg px-4 py-2"
//   onChange={(e) =>
//     setFormData({ ...formData, github: e.target.value })
//   }
// />


//         <textarea
//           placeholder="Message (optional)"
//           className="w-full border rounded-lg px-4 py-2"
//           rows={4}
//           onChange={(e) =>
//             setFormData({ ...formData, message: e.target.value })
//           }
//         />

        

//       </form>
//       <div className="shrink-0 px-8 py-6 border-t">
//   <button
//     type="submit"
//     form="apply-form"
//     disabled={submitting}
//     className="w-full py-3 rounded-lg bg-[#1b1761] text-white font-medium hover:opacity-90"
//   >
//     {submitting ? "Submitting..." : "Submit Application"}
//   </button>
// </div>

//     </div>
//   </div>
// )}


//       </div>
//     </section>
//   );
// };

// export default OpenPositions;















































import { db } from "../../Firebase_Config/firebaseConfig";
import {
  collection,
  query,
  where,
  onSnapshot,
}from "firebase/firestore";
import { useEffect, useState } from "react";


const formatLabel = (value = "") => {
  return value
    .toString()
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};



const FilterSection = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between text-left font-medium"
      >
        <span>{title}</span>
        <span className="text-xl">{open ? "−" : "+"}</span>
      </button>

      <div className="h-px bg-blue-900 my-3" />

      {open && <div className="space-y-2">{children}</div>}
    </div>
  );
};
const FilterCheckbox = ({ label, checked, onChange }) => (
  <label className="flex items-center gap-3 text-sm text-gray-900 cursor-pointer">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="h-4 w-4 rounded border-gray-400 accent-blue-900"
    />
    {label}
  </label>
);



const OpenPositions = () => {
  const [showApplyForm, setShowApplyForm] = useState(false);
  const [applyJob, setApplyJob] = useState(null);
  const [expandedJobId, setExpandedJobId] = useState(null);
  const [filters, setFilters] = useState({
  location: [],
  jobType: [],
  experience: [],
  areaOfInterest: [],
});
const clearFilters = () => {
  setFilters({
    location: [],
    jobType: [],
    experience: [],
    areaOfInterest: [],
  });
};

const toggleFilter = (key, value) => {
  setFilters((prev) => {
    const exists = prev[key].includes(value);
    return {
      ...prev,
      [key]: exists
        ? prev[key].filter((v) => v !== value)
        : [...prev[key], value],
    };
  });
};

const [sortBy, setSortBy] = useState("newest");





const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  message: "",
  resumeLink: "",
  photoLink: "",
  linkedin: "",
  github: "",
});
const COMPANY = "valsco";


const [submitting, setSubmitting] = useState(false);


  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
useEffect(() => {
  if (selectedJob) {
    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  } else {
    const scrollY = Math.abs(
      parseInt(document.body.style.top || "0", 10)
    );

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";

    window.scrollTo(0, scrollY);
  }

  return () => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
  };
}, [selectedJob]);





  useEffect(() => {
    const q = query(
      collection(db, "job-openings"),
      where("isOpen", "==", true),
      where("company.valsco", "==", true) 
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setJobs(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const filteredJobs = jobs
  .filter((job) => {
    if (
      filters.location.length &&
      !filters.location.includes(job.location)
    )
      return false;

    if (
      filters.jobType.length &&
      !filters.jobType.includes(job.jobType)
    )
      return false;

    // EXPERIENCE FILTER
// EXPERIENCE FILTER
if (filters.experience.length) {
  const expText = job.experience?.toString().toLowerCase() || "";

  // extract number from "3 years", "2", etc.
  const match = expText.match(/\d+/);
  const years = match ? parseInt(match[0], 10) : null;

  const matchesRange = filters.experience.some(range => {
    // 0–2 includes empty / missing experience
    if (range === "0-2") {
      if (years === null) return true;
      return years >= 0 && years <= 2;
    }

    // other ranges REQUIRE a number
    if (years === null) return false;

    if (range === "2-5") return years >= 2 && years <= 5;
    if (range === "6-10") return years >= 6 && years <= 10;
    if (range === "10+") return years > 10;

    return false;
  });

  if (!matchesRange) return false;
}



    // AREA OF INTEREST FILTER (based on job.title)
if (filters.areaOfInterest.length) {
  const title = job.title?.toLowerCase() || "";

  const hasMatch = filters.areaOfInterest.some(area =>
    title.includes(area)
  );

  if (!hasMatch) return false;
}

    return true;
  })
  .sort((a, b) => {
    if (sortBy === "newest") {
      return (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0);
    }
    if (sortBy === "oldest") {
      return (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0);
    }
    return 0;
  });

  const locationOptions = Array.from(
  new Set(
    jobs
      .map((job) => job.location)
      .filter(Boolean) // removes null / undefined
  )
);

const jobTypeOptions = Array.from(
  new Set(
    jobs
      .map((job) => job.jobType)
      .filter(Boolean)
  )
);




  return (
    
    <section className="py-4 bg-white-50" id="open-positions">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
  {/* LEFT */}
  <div>
    <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
      Open Positions
    </h2>
    <p className="mt-1 text-gray-600 text-sm md:text-base">
      Roles currently open at Valsco Technology.
    </p>
  </div>

  {/* RIGHT */}
  <div className="flex items-center justify-between md:justify-end gap-4 text-sm">
    <span className="text-gray-700">
      <strong>{filteredJobs.length}</strong> Results
    </span>

    <select
      value={sortBy}
      onChange={(e) => setSortBy(e.target.value)}
      className="border rounded-md px-3 py-2 text-sm"
    >
      <option value="newest">Sort by Newest</option>
      <option value="oldest">Sort by Oldest</option>
    </select>
  </div>
</div>



<div className="grid grid-cols-1 md:grid-cols-[260px_1fr] gap-10">
  {/* FILTERS */}
{/* FILTERS CARD */}
{/* FILTERS CARD */}
<div className="bg-white rounded-2xl p-6 border border-gray-200">
  {/* Header */}
  <div className="flex items-center justify-between mb-6">
    <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
    <button
      onClick={clearFilters}
      className="text-blue-900 text-sm flex items-center gap-1 hover:underline"
    >
      Clear filters ⟳
    </button>
  </div>

  <div className="space-y-6">
    {/* LOCATION */}
    <FilterSection title="Location">
      {locationOptions.map((loc) => (
  <FilterCheckbox
    key={loc}
    label={formatLabel(loc)}
    checked={filters.location.includes(loc)}
    onChange={() => toggleFilter("location", loc)}
  />
))}

    </FilterSection>

    {/* AREA OF INTEREST */}
    <FilterSection title="Area of Interest">
      {["Frontend", "Backend", "Business Developement", "Law Intern", "Sales", "Social Media Marketing","UI UX Developement"].map(
        (area) => (
          <FilterCheckbox
            key={area}
            label={area}
            checked={filters.areaOfInterest.includes(area.toLowerCase())}

            onChange={() =>
  toggleFilter("areaOfInterest", area.toLowerCase())
}

          />
        )
      )}
    </FilterSection>

    {/* JOB TYPE */}
    <FilterSection title="Job Type">
      {jobTypeOptions.map((type) => (
  <FilterCheckbox
    key={type}
    label={type}
    checked={filters.jobType.includes(type)}
    onChange={() => toggleFilter("jobType", type)}
  />
))}

    </FilterSection>

    {/* EXPERIENCE */}
    <FilterSection title="Experience">
      {["0-2", "2-5", "6-10", "10+"].map((exp) => (
        <FilterCheckbox
          key={exp}
          label={exp}
          checked={filters.experience.includes(exp)}
          onChange={() => toggleFilter("experience", exp)}
        />
      ))}
    </FilterSection>
  </div>
</div>




        {/* Content */}
        {loading ? (
  <div className="flex items-center justify-center py-20">
    <p className="text-gray-500">Loading openings…</p>
  </div>
) : filteredJobs.length === 0 ? (
  <div className="flex items-center justify-center py-20">
    <p className="text-gray-500 text-lg text-center max-w-md">
      No open roles right now. Please check back soon.
    </p>
  </div>
) : (

          <div className="open-jobs-scroll flex flex-col gap-6 max-h-[70vh] overflow-y-auto pr-3">



  


            {filteredJobs.map((job) => {


  const isExpanded = expandedJobId === job.id;

  return (
    <div
      key={job.id}
      className="w-full bg-white border border-gray-200 rounded-xl px-8 py-6 transition-all hover:shadow-md"

    >
      {/* HEADER */}
      <div className="flex justify-between items-start">
        <div>
          <h3 className="text-xl font-semibold text-gray-900">
            {job.title}
          </h3>

          <p className="mt-2 text-sm text-gray-500">
  {job.location || "Remote"} |{" "}
  {job.jobType || "Full time"} |{" "}
  Experience: {job.experience || "—"} |{" "}
  Salary: {job.salary || "—"}
</p>

        </div>

        {/* + / - BUTTON */}
        <button
          onClick={() =>
            setExpandedJobId(isExpanded ? null : job.id)
          }
          className="h-10 w-10 bg-[#1b1761] text-white rounded-md text-xl hover:opacity-90"

        >
          {isExpanded ? "−" : "+"}
        </button>
      </div>

      {/* EXPANDED CONTENT */}
      {isExpanded && (
  <div className="mt-6 text-gray-700 space-y-4">


          <div>
            <strong className="text-gray-900">Job Description</strong>
            <p className="mt-2 whitespace-pre-line text-gray-700">
  {job.description}
</p>

          </div>

          <div className="pt-4">
            <button
              onClick={() => {
                setApplyJob(job);
                setShowApplyForm(true);
              }}
              className="px-8 py-3 bg-[#1b1761] text-white rounded-lg hover:opacity-90 transition"

            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
})}

          </div>
        )}
      </div>
      {selectedJob && (
  <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4">
    
    {/* MODAL CONTAINER */}
    <div className="bg-white w-full max-w-lg rounded-2xl relative flex flex-col max-h-[90vh] pt-6">


      {/* HEADER (NON-SCROLLING) */}
      <div className="shrink-0 px-8 pt-8 pb-4 border-b relative">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
          onClick={() => setSelectedJob(null)}
        >
          ✕
        </button>

        <h3 className="text-2xl font-semibold text-gray-900">
          {selectedJob.title}
        </h3>

        <p className="mt-2 whitespace-pre-line text-gray-700">
          {selectedJob.jobType || "Role"} · {selectedJob.location || "Remote"}
        </p>
      </div>

      {/* BODY (SCROLLS IF CONTENT IS LONG) */}
      <div className="flex-1 overflow-y-auto px-8 py-6 text-sm text-gray-700 space-y-4">
        <div>
          <strong>Description</strong>
          <p className="mt-1 whitespace-pre-line break-words">
            {selectedJob.description || "No description provided."}
          </p>
        </div>

        {selectedJob.salary && (
          <div>
            <strong>Salary</strong>
            <p>{selectedJob.salary}</p>
          </div>
        )}

        <div>
          <strong>Company</strong>
          <p>Valsco Technology</p>
        </div>

        <div>
          <strong>Status</strong>
          <p>{selectedJob.isOpen ? "Open" : "Closed"}</p>
        </div>
      </div>

      {/* FOOTER (NON-SCROLLING) */}
      <div className="shrink-0 px-8 py-6 border-t flex justify-center">
        <button
  type="button"
  className="px-10 py-3 min-w-[220px] rounded-lg bg-[#1b1761] text-white"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedJob(null);      // close view
    setApplyJob(selectedJob);  // pass job
    setShowApplyForm(true);
  }}
>
  Apply
</button>

      </div>

    </div>
  </div>
)}

{showApplyForm && applyJob && (
  <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center px-4">
    <div className="bg-white w-full max-w-lg rounded-2xl relative flex flex-col max-h-[90vh] pt-6">


      <div className="shrink-0 px-8 pt-8 pb-4 border-b relative">
  <button
    className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
    onClick={() => setShowApplyForm(false)}
  >
    ✕
  </button>

  <h3 className="text-2xl font-semibold text-gray-900">
    Apply for {applyJob.title}
  </h3>
</div>

      <form
  id="apply-form"
  className="flex-1 overflow-y-auto px-8 py-6 space-y-4"
  onSubmit={async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const form = new FormData();
      form.append("jobTitle", applyJob.title);
      form.append("company", COMPANY);  
      form.append("name", formData.name);
      form.append("email", formData.email);
      form.append("phone", formData.phone);
      form.append("message", formData.message);
      form.append("resumeLink", formData.resumeLink);
      form.append("photoLink", formData.photoLink);
      form.append("linkedin", formData.linkedin);
      form.append("github", formData.github);

      await fetch(
        "https://script.google.com/macros/s/AKfycbyabONFenc7qmuXrmVO3fntc5z53eOUursP8SglMxuq0iA-BEeezabpWHG39cBg7zw_Vg/exec",
        { method: "POST", body: form , mode:"no-cors"}
      );

      alert("Application submitted successfully!");
      setShowApplyForm(false);
    } catch (err) {
      console.error(err);
      alert("Submission failed");
    } finally {
      setSubmitting(false);
    }
  }}
>

        <input
          required
          placeholder="Full Name"
          className="w-full border rounded-lg px-4 py-2"
          onChange={(e) =>
            setFormData({ ...formData, name: e.target.value })
          }
        />

        <input
          required
          type="email"
          placeholder="Email"
          className="w-full border rounded-lg px-4 py-2"
          onChange={(e) =>
            setFormData({ ...formData, email: e.target.value })
          }
        />

        <input
          required
          placeholder="Phone"
          className="w-full border rounded-lg px-4 py-2"
          onChange={(e) =>
            setFormData({ ...formData, phone: e.target.value })
          }
        />
        <p className="text-xs text-gray-500">
  Please ensure links are publicly accessible (Google Drive preferred).
</p>


        <input
  required
  type="url"
  placeholder="Resume Drive Link"
  className="w-full border rounded-lg px-4 py-2"
  onChange={(e) =>
    setFormData({ ...formData, resumeLink: e.target.value })
  }
/>

<input
  type="url"
  placeholder="Passport Size Photo Drive Link"
  className="w-full border rounded-lg px-4 py-2"
  onChange={(e) =>
    setFormData({ ...formData, photoLink: e.target.value })
  }
/>

<input
  type="url"
  placeholder="LinkedIn Profile Link"
  className="w-full border rounded-lg px-4 py-2"
  onChange={(e) =>
    setFormData({ ...formData, linkedin: e.target.value })
  }
/>

<input
  type="url"
  placeholder="GitHub Profile Link"
  className="w-full border rounded-lg px-4 py-2"
  onChange={(e) =>
    setFormData({ ...formData, github: e.target.value })
  }
/>


        <textarea
          placeholder="Message (optional)"
          className="w-full border rounded-lg px-4 py-2"
          rows={4}
          onChange={(e) =>
            setFormData({ ...formData, message: e.target.value })
          }
        />

        

      </form>
      <div className="shrink-0 px-8 py-6 border-t">
  <button
    type="submit"
    form="apply-form"
    disabled={submitting}
    className="w-full py-3 rounded-lg bg-[#1b1761] text-white font-medium hover:opacity-90"
  >
    {submitting ? "Submitting..." : "Submit Application"}
  </button>
</div>

    </div>
  </div>
)}


      </div>
    </section>
  );
};

export default OpenPositions;
